<template>
  <div>
    <p class="text-muted mt-2">
      {{ $t('google_ads.geo.help') }}
    </p>
    <b-row>
      <b-col
        v-for="kind in kinds"
        :key="kind"
        cols="12"
        md="6"
        lg="12"
      >
        <b-card
          border-variant="primary"
          :title="$t(`banners.targetings.${kind}`)"
          bg-variant="transparent"
          class="shadow-none"
          body-class="p-1 p-sm-2"
        >
          <b-form-group>
            <b-form-radio-group
              v-model="targetings[kind].status"
              class="mb-1"
              button-variant="outline-primary"
              :options="modes"
              buttons
              size="sm"
              :name="`offerwall-geo-${kind}-status`"
              :aria-label="$t(`banners.targetings.${kind}`)"
            />
            <label
              class="d-block"
              :for="`offerwall-geo-${kind}`"
            >{{ $t(`banners.targetings.${kind}`) }}</label>
            <v-select
              v-model="targetings[kind].params[fields[kind]]"
              :input-id="`offerwall-geo-${kind}`"
              :options="kind === 'country' ? countries : cities"
              :placeholder="$t(kind === 'country' ? 'sites.choosecountry' : 'banners.targetings-selects.city')"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              multiple
            />
            <small
              v-if="errors[kind]"
              class="text-danger d-block"
              role="alert"
            >
              {{ $t('campaign_targeting_validation.value_required', { target: $t(`banners.targetings.${kind}`) }) }}
            </small>
          </b-form-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import countriesAll from '@/libs/countries.json'

export default {
  components: {
    BRow, BCol, BCard, BFormGroup, BFormRadioGroup, VSelect,
  },
  props: {
    targetings: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
  },
  data: () => ({ kinds: ['country', 'city'], fields: { country: 'countries', city: 'cities' } }),
  computed: {
    modes() {
      return ['inactive', 'active', 'negative'].map(value => ({ value, text: this.$t(`banners.targetings-selects.${value}`) }))
    },
    countries() {
      return Object.keys(countriesAll)
    },
    cities() {
      const { country } = this.targetings
      const selected = country.params.countries || []
      const source = country.status === 'active' && selected.length ? selected : this.countries
      return [...new Set(source.reduce((all, name) => all.concat(countriesAll[name] || []), []))]
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
